export interface Vec2 {
  x: number
  y: number
}

export const enum DietType {
  Herbivore = 'herbivore',
  Carnivore = 'carnivore',
  Omnivore = 'omnivore',
}

/**
 * 食性スコアからDietTypeを判定（表示・統計集計用）
 * score >= 0.7 → 草食, score <= 0.3 → 肉食, それ以外 → 雑食
 */
export function getDietType(dietScore: number): DietType {
  if (dietScore >= 0.7) return DietType.Herbivore
  if (dietScore <= 0.3) return DietType.Carnivore
  return DietType.Omnivore
}

/** 生物の個性パラメーター（遺伝形質） */
export interface Traits {
  /** 移動速度 (px/frame) */
  speed: number
  /** 視野半径 (px) */
  visionRange: number
  /** 体のサイズ (半径 px) */
  size: number
  /**
   * 食性スコア: 0.0 = 完全肉食, 1.0 = 完全草食
   * >= 0.7 → 草食傾向, <= 0.3 → 肉食傾向, 0.3〜0.7 → 雑食傾向
   * 繁殖時に変異し、進化する
   */
  dietScore: number
  /** HSL の色相 (0-360) */
  hue: number
  /** エネルギー消費率の乗数 */
  metabolismRate: number
  /** 繁殖力: 高いほど低いエネルギーで繁殖できる (0.5〜1.5) */
  fertilityRate: number
}

/** 障害物（円形） */
export interface Obstacle {
  pos: Vec2
  radius: number
}

/** 個体数の時系列スナップショット */
export interface PopSnapshot {
  tick: number
  herbivores: number
  carnivores: number
  omnivores: number
}

/** 初期個体数の設定 */
export interface PopulationConfig {
  herbivores: number
  carnivores: number
  omnivores: number
}
